"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RDPStream = void 0;
const types_1 = require("@refinitiv-data/types");
const session_1 = require("../../session");
const rdp_stream_1 = require("./rdp-stream");
class RDPStream {
    static Definition(params) {
        return {
            getStream: (session = (0, session_1.getDefault)()) => {
                return new rdp_stream_1.RDPStreamImpl(session, typeof params === 'string' ? { universe: params } : params);
            },
        };
    }
}
exports.RDPStream = RDPStream;
RDPStream.Event = types_1.RDPStreamEvent;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmRwLXN0cmVhbS5jbGFzcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9kZWxpdmVyeS9zdHJlYW0vcmRwLXN0cmVhbS5jbGFzcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxpREFBc0k7QUFFdEksMkNBQTJDO0FBQzNDLDZDQUE2QztBQUk3QyxNQUFhLFNBQVM7SUFLWCxNQUFNLENBQUMsVUFBVSxDQUFDLE1BQXVDO1FBQzVELE9BQU87WUFDSCxTQUFTLEVBQUUsQ0FBQyxVQUFtQixJQUFBLG9CQUFVLEdBQUUsRUFBYyxFQUFFO2dCQUN2RCxPQUFPLElBQUksMEJBQWEsQ0FBQyxPQUFPLEVBQUUsT0FBTyxNQUFNLEtBQUssUUFBUSxDQUFDLENBQUMsQ0FBQyxFQUFFLFFBQVEsRUFBRSxNQUFNLEVBQUUsQ0FBQyxDQUFDLENBQUMsTUFBTSxDQUFDLENBQUM7WUFDbEcsQ0FBQztTQUNKLENBQUM7SUFDTixDQUFDOztBQVhMLDhCQVlDO0FBWGlCLGVBQUssR0FBRyxzQkFBYyxDQUFDIn0=